import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';
import { bindServices } from '@/services/api';

const api = bindServices('manageReportGroups');

import {
  queryEditActive,
  queryEditPath,
  queryListPermissions,
  querySavePermission,
} from './service';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'manageReportGroups',
  state: {
    newReportGroup: false,
    newPermission: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    listUserPermission: null,
    listPositionPermission: null,
    listUserGroupPermission: null,
    listAreaPermission: null,
    pagination: meta,
    select: 'id,isActive,order,name,powerBIReportGroupId, menuTitle',
    notSelectSearch: 'order',
    paramsView: {
      select:
        'id,isActive,order,name,powerBIReportGroupId,isAutoManaged,menuTitle,permissionsFiltersLogicalOperator',
      expand: {
        powerBIServerConfiguration: { select: 'name' },
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },
    paramsEdit: {
      select:
        'id,isActive,order,name,powerBIReportGroupId,powerBIServerConfigurationId,isAutoManaged,menuTitle,permissionsFiltersLogicalOperator',
    },
    view: false,
    orderBy: '',
    id: null,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'reportGroup/paged',
          params: payload,
        });
        yield put({
          type: 'queryReportGroups',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *fetchListPermissions({ payload }, { call, put }) {
      try {
        const response = yield call(queryListPermissions, payload);
        yield put({
          type: 'queryPermission',
          payload: {
            data: response,
            name: payload.name,
            field: payload.field,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewReportGroup({ payload }, { put }) {
      yield put({
        type: 'addReportGroups',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewReportGroups',
          payload,
        });
      }
    },

    *saveNewReportGroup({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'reportGroup',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveReportGroup',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *editItemReportGroup({ payload }, { call, put }) {
      try {
        const table = yield call(api.getById, {
          route: 'reportGroup',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editReportGroups',
          payload: {
            state: true,
            ...payload,
            item: table,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *saveEditReportGroup({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'reportGroup',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveReportGroup',
          payload: response,
        });

        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });

        const response = yield call(api.apiRoute, {
          route: `reportGroup/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'saveReportGroup',
          payload: response,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        if (error && error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (e) {
        /*  */
      }
    },

    *editPath({ payload, params, id }, { call, put }) {
      try {
        yield call(queryEditPath, params, id);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (e) {
        /*  */
      }
    },

    *showItemUser({ view }, { put }) {
      yield put({
        type: 'showEditItemUser',
        view,
      });
    },

    *addNewPermission({ payload }, { put }) {
      yield put({
        type: 'addPermission',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *addListPermission({ payload }, { put }) {
      yield put({
        type: 'addListPermissions',
        payload,
      });
    },

    *deleteItemPermision({ payload }, { put }) {
      yield put({
        type: 'deleteItemPermisions',
        payload,
      });
      yield put({
        type: `global/modalConfirm`,
        state: false,
        id: null,
      });
    },

    *savePermission({ payload }, { call, put }) {
      try {
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'hidePermission',
        });
        yield call(querySavePermission, payload);
        yield put({
          type: 'addPermission',
          payload: {
            state: false,
            item: null,
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },
  },
  reducers: {
    queryReportGroups(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addReportGroups(state, { payload }) {
      return {
        ...state,
        newReportGroup: payload.state,
        newPermission: false,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewReportGroups(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editReportGroups(state, { payload }) {
      const item = {
        ...payload.item,
        permissionsFiltersLogicalOperator: payload.item.permissionsFiltersLogicalOperator
          ? payload.item.permissionsFiltersLogicalOperator
          : 0,
      };
      return {
        ...state,
        selectedItem: item,
        view: payload.view,
        id: payload.id,
      };
    },

    saveReportGroup(state, { payload }) {
      return {
        ...state,
        saveReportGroup: payload,
        newReportGroup: false,
        selectedItem: null,
        view: false,
      };
    },

    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));
      return {
        ...state,
        list,
      };
    },

    showEditItemReportGroup(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    addPermission(state, { payload }) {
      return {
        ...state,
        newPermission: payload.state,
        newReportGroup: false,
        selectedItem: payload.item,
      };
    },

    queryPermission(state, { payload }) {
      return {
        ...state,
        [payload.name]: _.map(payload.data, (l) => {
          return {
            ...l[payload.field],
            id: l[`${payload.field}Id`],
          };
        }),
      };
    },

    addListPermissions(state, { payload }) {
      return {
        ...state,
        [payload.name]: [...state[payload.name], payload.data],
      };
    },

    deleteItemPermisions(state, { payload }) {
      return {
        ...state,
        [payload.name]: _.filter(state[payload.name], (l) => l.id !== payload.id),
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hidePermission(state) {
      return {
        ...state,
        selectedItem: null,
        listUserPermission: null,
        listPositionPermission: null,
        listUserGroupPermission: null,
        listAreaPermission: null,
        formConfig: null,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newReportGroup: false,
        selectedItem: null,
        newPermission: false,
        formConfig: null,
        list: [],
        listUserPermission: null,
        listPositionPermission: null,
        listUserGroupPermission: null,
        listAreaPermission: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
